import { Component, inject, Input, ViewChild } from "@angular/core";
import { CreditsService } from "@bitwarden/web-vault/app/services/syncing/gloss-credits/credits.service";
import { CardGlareComponent } from "@bitwarden/web-vault/app/components/animation/card-glare/card-glare.component";

@Component({
  selector: "app-platinum-card",
  templateUrl: "./platinum-card.component.html",
  host: { class: "tw-block" },
})
export class PlatinumCardComponent {
  @Input() layout: "rail" | "stack" = "rail";

  creditsService = inject(CreditsService);

  @ViewChild("glare") private glare!: CardGlareComponent;

  /** Replays the card's glare sweep — used by the mobile flip stack when this card swaps to front. */
  playGlare(): void {
    this.glare?.play();
  }
}
